<template>
  <!-- 主页页脚部分 -->
  <!-- 页面底部位置 -->
  <div class="E_footer_centerBox">
      <!-- 页面底部位置 -->
    <div class="E_footer_box">
        <!-- 页脚位置上 -->
        <div class="E_footer_top_box">
            <div class="E_footer_top E_contentBox">
                <table>
                    <thead>
                        <!-- 标题部分 -->
                        <tr class="E_thead_box">
                            <td class="E_xby">关于新百易</td>
                            <td class="E_system">业务体系</td>
                            <td class="E_tool">辅导工具</td>
                            <td class="E_link">联系我们</td>
                            <td class="E_wechat">微信公众号</td>
                            <td class="E_TikTok">抖音号</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="E_body_box">
                            <td class="E_xby_item">
                                <ul class="E_EditSortable_Y">
                                    <li>
                                        <a class="hove_p" href="http://www.5ksw.com/">
                                            <span class="editTargetTxT">企业官网</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a class="hove_p" href="http://www.5ksw.com/about" >
                                            <span class="editTargetTxT">公司简介</span>

                                        </a>
                                    </li>
                                    <li>
                                        <a class="hove_p" href="/Investment">
                                            <span class="editTargetTxT">合作加盟</span>


                                        </a>
                                    </li>
                                    <li>
                                        <a class="hove_p" href="http://www.5ksw.com/welfare">
                                            <span class="editTargetTxT">人才招聘</span>


                                        </a>
                                    </li>
                                    <li>
                                        <a class="hove_p" href="http://www.5ksw.com/contact">
                                            <span class="editTargetTxT">联系我们</span>


                                        </a>
                                    </li>
                                </ul>
                            </td>
                            <td class="E_system_item">
                                <ul class="E_EditSortable_Y">
                                    <li>
                                        <a class="hove_p" href="/Productcentre?type=face">
                                            <span class="editTargetTxT">面授课程</span>


                                        </a>
                                    </li>
                                    <li>
                                        <a class="hove_p" href="/Productcentre?type=class">
                                            <span class="editTargetTxT">网络课程</span>


                                        </a>
                                    </li>
                                    <li>
                                        <a class="hove_p" href="/Productcentre?type=live">
                                            <span class="editTargetTxT">直播课程</span>


                                        </a>
                                    </li>
                                    <li>
                                        <a class="hove_p" href="/tk">
                                            <span class="editTargetTxT">智能题库</span>


                                        </a>
                                    </li>
                                    <li>
                                        <a class="hove_p" href="/tk">
                                            <span class="editTargetTxT">辅导资料</span>


                                        </a>
                                    </li>
                                </ul>
                            </td>
                            <td class="E_tool_items">
                                <ul class="E_EditSortable_Y">
                                    <li>
                                        <a class="hove_p" href="/xby">
                                            <span class="editTargetTxT">新百易导航</span>


                                        </a>
                                    </li>
                                    <li>
                                        <a class="hove_p" href="/tk">
                                            <span class="editTargetTxT">历年真题</span>


                                        </a>
                                    </li>
                                    <li>
                                        <a class="hove_p" href="/Product#E_irregular_box_left">
                                            <span class="editTargetTxT">考编日历</span>


                                        </a>
                                    </li>
                                    <li>
                                        <a class="hove_p" href="/tk">
                                            <span class="editTargetTxT">智能测评</span>


                                        </a>
                                    </li>
                                </ul>
                            </td>
                            <td class="E_link_item">
                                <div class="E_link_item_chil ">
                                    <p class="E_link_item_title"><i class="iconfont icon-kefu"></i> 在线人工客服
                                    </p>
                                    <div class="E_link_btn E_kefu_tips_parent">
                                        点击咨询
                                        <!-- 客服悬浮框 -->
                                        <div class="E_kefu_tips_box E_kefu_tips_top">
                                            <div class="E_kefu_tips_box_img">
                                                <img src="https://upload.5kjs.com/upload/agency_wechat/20220421/e7a22ef3f3156d3c9cc06f67792bf554.png" alt="">
                                            </div>
                                            <P class="E_kefu_tips_box_title">
                                                扫码添加客服
                                            </P>
                                        </div>
                                    </div>
                                </div>
                                <div class="E_link_item_chil">
                                    <p class="E_link_item_title"><i class="iconfont icon-dianhua"></i> 全国免费服务热线</p>
                                    <p class="E_link_item_content">400-0057-228</p>
                                </div>
                                <div class="E_link_item_chil">
                                    <p class="E_link_item_title"><i class="iconfont icon-weizhi"></i> 新百易教育集团</p>
                                    <p class="E_link_item_content">
                                        湖南省长沙市芙蓉区五一大道人瑞 · 潇湘国际9楼918号
                                    </p>
                                </div>

                            </td>
                            <td class="E_wechat_item edit ">
                                <img class="editTarget" src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/eiditIndex_img/head/gongzhonghao.jpg" alt="">
                            </td>
                            <td class="E_TikTok_item  edit ">
                                <img class="editTarget" src="https://fview.5kjs.com/pc_img/theme/newtheme/newstyle/img/eiditIndex_img/head/douyin.jpg" alt="">
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>



        <!-- 页脚位置上 -->
        <div class="E_footer_bottom">
            <p>湖南新百易教育提供教师考试辅导培训班，并转载湖南教师类招聘公告信息</p>
            <p>网校首页：www.jszg.com 企业官网：www.5ksw.com 全国免费服务热线：400-0057-228</p>
            <p>出版物经营许可证 新出发芙字 第2017054号 湘ICP备案 000000号 Copyright©2007-2022 湖南新百易教育咨询有限公司 .All Right Reserved</p>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  neme: "Footer",
  methods: {
    jup() {
      window.location.href = window.location.origin;
    },
  },
};
</script>

<style lang="less" scoped>
// 客服弹框
.E_kefu_tips_parent {
  position: relative;
  cursor: pointer;

  .E_kefu_tips_box {
    display: none;
    border: 1px solid #eee;
    position: absolute;
    z-index: 9;
    top: 0;
    left: 50%;
    width: 11.5rem;
    height: 12rem;
    color: #666;
    font-size: .75rem;
    text-align: center;
    background-color: #fff;
    box-shadow: 0 2px .625rem #aaa;
    transition: all 200ms;
    border-radius: .3125rem;
    transform: translate(-50%, -100%);

    .E_kefu_tips_box_img {
      width: 8.5625rem;
      margin: .625rem auto;

      img {
        width: 100%;
      }
    }
  }

  .E_kefu_tips_box::after {
    content: '';
    position: absolute;
    left: 50%;
    margin-left: -0.375rem;
    bottom: -0.8125rem;
    width: 0;
    height: 0;
    border-width: .5rem .375rem .375rem .375rem;
    border-style: solid;
    border-color: #fff transparent transparent transparent;
  }


  // 悬浮在上方（默认）
  .E_kefu_tips_top {
    top: 0;
    left: 50%;
    transform: translate(-50%, -100%);
  }

  // 悬浮在下方
  .E_kefu_tips_bottom {
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 35%);
  }

  .E_kefu_tips_bottom::after {
    left: 50%;
    margin-left: -0.375rem;
    top: -0.8125rem;
    border-color: transparent transparent #fff transparent;
  }
}

.E_kefu_tips_parent:hover {
  .E_kefu_tips_box {
    display: block;
  }
}


// 页脚背景
.footColor {
  background-color: #2E3642;
}


// flex布局
.flexStyle(@direction, @item, @justify) {
  display: flex;
  flex-direction: @direction;
  align-items: @item ;
  justify-content: @justify ;
}


.E_footer_centerBox {
  .footColor();
}

.E_footer_box {
  // margin-top: 3.1875rem;

  .footColor();

  .E_footer_top_box {
    border-bottom: 1px solid rgba(251, 251, 251, .1);

    .E_footer_top {
      width: 1440px;
      margin: auto;
      height: 20.3125rem;
      padding-top: 3.6875rem;

      table {
        border-collapse: inherit;
      }

      // 标题部分
      .E_thead_box {
        font-size: 1.125rem;
        font-family: Microsoft YaHei;
        font-weight: 300;
        color: #FFFFFF;

        td:nth-child(n+2) {
          text-align: center;
        }

        // 关于新百易
        .E_xby {
          width: 8.75rem;
        }

        // 业务体系
        .E_system {
          width: 14.25rem;
        }

        // 辅导工具
        .E_tool {
          width: 13.875rem;
        }

        // 联系我们
        .E_link {
          width: 28.4375rem;
        }

        // 微信公众号
        .E_wechat {
          width: 13.5625rem;
        }

        // 抖音号
        .E_TikTok {
          width: 8.1875rem;
        }
      }

      // 内容部分
      .E_body_box {
        font-size: 1rem;
        font-family: Microsoft YaHei;
        font-weight: 300;
        color: #989899;

        a{
           color: #989899;
        }

        td {
          vertical-align: top;
          padding-top: .875rem;
          border-right: 1px solid;
          border-image: -webkit-linear-gradient(#2E3642, #3c444f, #2E3642) 20 20;

          border-image: -moz-linear-gradient(#2E3642, #3c444f, #2E3642) 20 20;

          border-image: -o-linear-gradient(#2E3642, #3c444f, #2E3642) 20 20;

          border-image: linear-gradient(#2E3642, #3c444f, #2E3642) 20 20;
        }

        .E_xby_item {
          li {
            margin-top: .875rem;
          }
        }

        .E_system_item,
        .E_tool_items {
          li {
            margin-top: .875rem;
            text-align: center;
          }
        }

        .E_link_item {
          padding-left: 4.375rem;

          .E_link_item_chil {
            padding-top: .875rem;
            margin-bottom: .8125rem;

            .E_link_item_title {
              font-size: 1rem;
              font-family: Microsoft YaHei;
              font-weight: 300;
              color: #FFFFFF;
            }

            .E_link_btn {
              margin-top: .25rem;
              display: inline-block;
              padding: 0 .625rem;
              height: 1.375rem;
              background: #4C525D;
              border-radius: .3125rem;
              line-height: 1.375rem;
              font-size: .875rem;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #FFF;
            }

            .E_link_item_content {
              font-size: .875rem;
              font-family: Microsoft YaHei;
              font-weight: 300;
              color: #989899;
            }
          }
        }

        .E_wechat_item,
        .E_TikTok_item {
          border-right: none;
          text-align: center;

          img {
            width: 8.1875rem;
            height: 8.1875rem;
          }
        }
      }
    }
  }

  .E_footer_bottom {
    .flexStyle(column, center, center);
    height: 5.9375rem;
    font-size: .875rem;
    font-family: Microsoft YaHei;
    font-weight: 300;
    color: #747475;
    text-align: center;
    line-height: 1.375rem;
  }
}
</style>